import { useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';

import { text } from '../text';
import { hooks } from '../hooks';
import { utils } from '../utils';
import { theme } from '../constants';
import { components } from '../components';
interface Notification {
  id: number;
  icon: string;
  heading: string;
  description: string;
  time: string;
}

// const notifications: Notification[] = [
//   {
//     id: 1,
//     icon: '🔔',
//     heading: 'New Feature Added!',
//     description: 'We have added a new feature that you will love! Check it out now.',
//     time: '2 hours ago',
//   },
//   {
//     id: 2,
//     icon: '⚡',
//     heading: 'System Maintenance',
//     description: 'Our servers will undergo maintenance from 3:00 AM to 5:00 AM.',
//     time: '1 day ago',
//   },
//   {
//     id: 3,
//     icon: '📣',
//     heading: 'New Update Available',
//     description: 'A new update is available for the app. Update now to enjoy the new features.',
//     time: '3 days ago',
//   },
//   // Add more notifications here
// ];



// const notifications: Notification[] = [
//   {
//     id: 4,
//     icon: '🏡',
//     heading: 'New PG Listed in Koramangala!',
//     description: 'A fully furnished PG is now available in Koramangala starting at ₹7,500/month.',
//     time: '3 hours ago',
//   },
//   {
//     id: 5,
//     icon: '🔥',
//     heading: 'Hot Property Alert!',
//     description: 'A popular flat in Indiranagar was just listed. It’s getting a lot of attention!',
//     time: '6 hours ago',
//   },
//   {
//     id: 6,
//     icon: '📅',
//     heading: 'Rent Due Reminder',
//     description: 'Your rent for June is due on 5th. Don’t forget to make the payment on time.',
//     time: '1 day ago',
//   },
//   {
//     id: 7,
//     icon: '✅',
//     heading: 'Booking Confirmed',
//     description: 'Your booking for Green Nest PG has been confirmed. Welcome aboard!',
//     time: '2 days ago',
//   },
//   {
//     id: 8,
//     icon: '🏙️',
//     heading: 'Flatmate Needed!',
//     description: 'Your current flatmate is moving out. Looking for someone to share your 2BHK.',
//     time: '3 days ago',
//   },
//   {
//     id: 9,
//     icon: '🛠️',
//     heading: 'Maintenance Request Resolved',
//     description: 'Your maintenance request for water leakage has been successfully addressed.',
//     time: '4 days ago',
//   },
//   {
//     id: 10,
//     icon: '📍',
//     heading: 'Price Drop in BTM Layout!',
//     description: 'Rental prices have dropped for multiple PGs in BTM Layout. Check them out!',
//     time: '5 days ago',
//   }
// ];

const notifications: Notification[] = [
  {
    id: 1,
    icon: '🎁',
    heading: '10 Leads Free!',
    description: 'Get 10 leads free on your first registration on the PMS app.',
    time: '1 day ago',
  },
  {
    id: 2,
    icon: '💬',
    heading: 'Talk to Your Landlord',
    description: 'Ask your landlord about loans on rent and security deposit.',
    time: '6 hours ago',
  }
];


const NotificationPage1: React.FC = () => {
  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title='Notifications'
        goBack={true}
        skip={false}
        clear={false}
        clearOnClicked={() => { }}
      />
    );
  };



  // const renderContent = (): JSX.Element => {
  //   return (
  //     <div className="notification-page">

  //       <div className="notification-list">
  //         {notifications.map((notification) => (
  //           <div key={notification.id} className="notification-item">
  //             <div className="notification-left">
  //               {/* Icon */}
  //               <div className="notification-icon">{notification.icon}</div>
  //             </div>

  //             <div className="notification-center">
  //               {/* Heading */}
  //               <div className="notification-heading">{notification.heading}</div>
  //               {/* Description */}
  //               <div className="notification-description">{notification.description}</div>
  //             </div>

  //             <div className="notification-right">
  //               {/* Time */}
  //               <div className="notification-time">{notification.time}</div>
  //             </div>
  //           </div>
  //         ))}
  //       </div>

  //       <style>{`
  //       .notification-page {
  //         font-family: Arial, sans-serif;
  //         padding: 20px;
  //       }

  //       .notification-list {
  //         display: flex;
  //         flex-direction: column;
  //         gap: 16px;
  //       }

  //       .notification-item {
  //         display: flex;
  //         justify-content: space-between;
  //         align-items: flex-start;
  //         padding: 12px;
  //         border: 1px solid #ddd;
  //         border-radius: 8px;
  //         background-color: #f9f9f9;
  //       }

  //       .notification-left {
  //         flex: 0 0 40px;
  //         display: flex;
  //         justify-content: center;
  //         align-items: center;
  //       }

  //       .notification-icon {
  //         font-size: 24px;
  //       }

  //       .notification-center {
  //         flex: 1;
  //         padding: 0 16px;
  //       }

  //       .notification-heading {
  //         font-weight: bold;
  //         font-size: 16px;
  //         color: #333;
  //       }

  //       .notification-description {
  //         font-size: 14px;
  //         color: #666;
  //       }

  //       .notification-right {
  //         flex: 0 0 80px;
  //         display: flex;
  //         justify-content: flex-end;
  //         align-items: center;
  //       }

  //       .notification-time {
  //         font-size: 12px;
  //         color: #999;
  //       }

  //       .notification-item:hover {
  //         background-color: #f0f0f0;
  //         cursor: pointer;
  //       }
  //     `}</style>
  //     </div>
  //   );
  // };



  // const renderContent = (): JSX.Element => {
  //   return (
  //     <div className="notification-container">
  //       {notifications.map((notification) => (
  //         <div key={notification.id} className="notification-card">
  //           <div className="notification-icon-wrapper">
  //             {notification.icon}
  //           </div>
  //           <div className="notification-content">
  //             <div style={{ display: "flex", justifyContent: "space-between" }}>
  //               <div className="notification-title">{notification.heading}</div>
  //               <div className="notification-meta">
  //                 <span className="notification-time">{notification.time}</span>
  //               </div>
  //             </div>
  //             <div className="notification-text">{notification.description}</div>
  //           </div>

  //         </div>
  //       ))}
  //     </div>
  //   );
  // };

  const renderContent = (): JSX.Element => {
    return (
      <div className="notification-container">
        {notifications.map((notification) => (
          <div key={notification.id} className="notification-card" >
            <div style={{ display: "flex" }}>
              <div className="notification-icon-wrapper">
                {notification.icon}
              </div>
              <div className="notification-content" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div className="notification-title">{notification.heading}</div>
                <div className="notification-meta">
                  <span className="notification-time">{notification.time}</span>
                </div>
              </div>
            </div>


            <div className="notification-text">{notification.description}</div>
          </div>

        ))
        }
      </div >
    );
  };


  return (
    <>
      {renderHeader()}
      <div
        className=''
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minHeight: '100vh',
          paddingBottom: 20,
          marginTop: 70
        }}
      >
        {renderContent()}
      </div>
    </>
  );
}
export default NotificationPage1;
